/* eslint-disable camelcase */

import { useSelector } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import HorizontalPlots from '../scatterPlot/HorizontalPlots';
import ReadConversationModalBody from '../readConversationModalBody/ReadConversationModalBody';
import { useGetCoachingConversationSearchQuery } from '../conversation/conversationSlice';
import { exportConversationExcel } from '../conversation/conversation-service';
import MetricModal from '../../features/coaching/metrics/MetricModal';
import { selectCurrentEmpid } from '../../pages/login/authSlice';
import {MetricColors} from '../metricMonthlySummaryCard/GradientDefs';
import { CoachingEntityTypes } from '../../utils/typeConstants';

const AgentDiscussionsPlot = ({
  nonMetricDiscussionsData,
  metricDiscussionsData,
  recieverId,
  receiverName,
  inputYear,
  inputMonth,
  metricIndex = 0,
  metricOmitted = false,  
}: {
  nonMetricDiscussionsData: any[];
  metricDiscussionsData: any[];
  recieverId: string;
  receiverName: string;
  inputYear: number;
  inputMonth: number;
  metricIndex?:number;
  metricOmitted?: boolean;
}) => {
  const styles = {
    innerContainer: {
      display: 'flex',
      flexDirection: 'row', // Horizontal layout for inner elements
      gap: '20px', // Space between monthly scatterplots
      alignItems: 'center', // Align items vertically in the row
    } as React.CSSProperties,
    monthContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    } as React.CSSProperties,
    monthTitle: {
      fontSize: '14px',
      fontWeight: 'bold',
      marginBottom: '5px',
    } as React.CSSProperties,
    separatorVertical: {
      width: '1px',
      height: '60px',
      backgroundColor: '#ddd',
      margin: '0 10px',
    } as React.CSSProperties,
  };

  const [displayModal, setDisplayModal] = useState(false);
  const [displayMetricModal, setDisplayMetricModal] = useState(false);
  const [conversationRowData, setConversationRowData] = useState<any>({});
  const [selectedRowItem, setSelectedRowItem] = useState<any>();
  const [commentView, setCommentView] = useState(false);
    const [isResponse, setIsResponse] = useState(false);
    const [id, setId] = useState(0);
    const loggedEmpNum = useSelector(selectCurrentEmpid); //author number
    const [showMetricModal, setShowMetricModal] = useState<boolean>(false);
    const [selectedMetricYear, setSelectedMetricYear] = useState<number>(inputYear);
    const [selectedMetricMonth, setSelectedMetricMonth] = useState<number>(inputMonth);
    const [selectedMetricBackgrndColor, setSelectedMetricBackgrndColor] = useState('#000000');

    const { data: conversationViewData } = useGetCoachingConversationSearchQuery({ 
      coachingConversationId:id
    },
    {
      skip: id<1,
    }
  );

  useEffect(() => {
    const colorIndex = metricOmitted ? 5 : metricIndex;
    const colors = MetricColors[colorIndex];
    setSelectedMetricBackgrndColor(colors?.bgColor);
  }, [metricIndex, metricOmitted])
  useEffect(() => {
    if (conversationViewData?.data[0]) {
      const cData = conversationViewData.data[0];
      console.log('conversationViewData', conversationViewData);
      setConversationRowData(cData);
            setDisplayModal(true);
      const rowDetails = {
        coaching_conversation_id: cData?.coaching_conversation_id,
        conversation_subject: cData?.conversation_subject,
        conversation_date: cData?.conversation_date,
        core_value_name: cData?.core_value_name,
        coaching_conversation_category_name: cData?.category_name,
        conversation_description: cData?.conversation_description,
        visible_to_recipient: cData?.visible_to_recipient,
        author_name: cData?.author,
        author_employee_number: cData?.author.split('(')[1]?.slice(0, 7),
        response_date: cData?.response_date,
        response_description: cData?.response_description,
        response_by_name: cData?.responder,
        response_employee_number: cData?.responder?.split('(')[1]?.slice(0, 7),
        recipient: cData?.recipient,
        core_value_id: cData?.core_value_id,
        conversation_documents:cData?.conversation_documents,
        acknowledge_employee_number:cData?.acknowledge_employee_number,
        acknowledge_date:cData?.acknowledge_date,
        acknowledged:cData?.acknowledged,
        employee_number: cData?.employee_number,
        coaching_behavior_id: cData?.coaching_behavior_id,
        coaching_behavior_name: cData?.coaching_behavior_name,
        coaching_skill_id: cData?.coaching_skill_id,
        coaching_skill_name: cData?.coaching_skill_name,

    };
      
    setSelectedRowItem(rowDetails);
            if (rowDetails?.response_description !== null) {
                setIsResponse(true);
            } else {
                setIsResponse(false);
            }
    }
  }, [conversationViewData]);
  
  const handleShapeClick = (id: number,date:string, type: string) => {
    console.log(`${type} Clicked ID: ${id} Date: ${date}`);

    if(type==='Metric'){
      const [year, month] = date.split('-');
      setSelectedMetricYear(year ? parseInt(year, 10) : inputYear);
      setSelectedMetricMonth(month ? parseInt(month,10) : inputMonth);
      setDisplayMetricModal(true);
      setShowMetricModal(true);
    }
    else if(type==='Non-Metric'){
      setId(id);
      setDisplayModal(true);
    }    

  };

  const modalHeader = () => {
    return (
        <h4 className="pe-3">
            <span style={{ fontWeight: 700 }} className="pt-2">
                {'Discussion Log'}
            </span>
        </h4>
    );
};

const modalFooter = () => {
  return (
      <React.Fragment>
          <Divider />
          <Button
              className="btn-secondary w-auto mr-2 me-2"
              onClick={() => {
                  setDisplayModal(false);
                  setCommentView(false);
                  setIsResponse(false);
              }}
          >
              Close
          </Button>
          <Button
              type="button"
              icon="pi pi-upload me-2"
              className="btn-export mr-2 me-2 float-end"
              style={{ backgroundColor: '#007bff', color: '#fff' }}
              onClick={() => {
                  exportConversationExcel('conversationlog', conversationRowData);
              }}
              data-pr-tooltip="XLS"
          >
              Export
          </Button>
      </React.Fragment>
  );
};


const renderMetricModel = () => {
  return (
      <MetricModal
          setDisplayModal={setDisplayMetricModal}
          displayModal={displayMetricModal}
          authorId={loggedEmpNum}
          recipientId={recieverId}
          inputYear={selectedMetricYear}
          inputMonth={selectedMetricMonth}
          recipientName={receiverName}
          entityTypeId={CoachingEntityTypes.General}
      />
  );
};

  return (
    <div
      className="card-body"
      style={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '20px',
        backgroundColor: selectedMetricBackgrndColor,
      }}
    >
      {/* Discussions Title */}
      <div style={{ flexShrink: 0 }}>
        <span className="ms-2 metricbargraph" style={{ margin: 0 }}>
          Discussions
        </span>
      </div>

      {/* Discussions Scatterplots */}
      <div
        className="mt-2"
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          flexGrow: 1,
        }}
      >
        {/* Non-Metric Discussions */}
          <div style={styles.innerContainer}>
            {nonMetricDiscussionsData.map((monthData, index) => (
              <React.Fragment key={index}>
                <div style={styles.monthContainer}>
                  <h3 style={styles.monthTitle}>{monthData.month}</h3>
                  <HorizontalPlots
                    items={monthData.items}
                    shape="hexagon"
                    onShapeClick={(id: number,date:string) => handleShapeClick(id,date, 'Non-Metric')}
                  />
                </div>
                {index < nonMetricDiscussionsData.length - 1 && (
                  <div style={styles.separatorVertical} />
                )}
              </React.Fragment>
            ))}
          </div>

     { (metricDiscussionsData?.length>0 && <Divider />)}

        {/* Metric Discussions */}
          <div style={styles.innerContainer}>
            {metricDiscussionsData.map((monthData, index) => (
              <React.Fragment key={index}>
                <div style={styles.monthContainer}>
                  <h3 style={styles.monthTitle}>{monthData.month}</h3>
                  <HorizontalPlots
                    items={monthData.items}
                    shape="triangle"
                    onShapeClick={(id: number,date:string) => handleShapeClick(id,date, 'Metric')}
                  />
                </div>
                {index < metricDiscussionsData.length - 1 && (
                  <div style={styles.separatorVertical} />
                )}
              </React.Fragment>
            ))}
          </div>

            <div>
                                    <div style={styles.innerContainer}>
                                        <span style={styles.monthTitle} className="ms-2 metricbargraph">
                                            <svg
                                                width="13"
                                                height="11"
                                                viewBox="0 0 13 11"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    id="Polygon 3"
                                                    d="M5.72058 0.549999C6.06699 -0.0500005 6.93301 -0.0500001 7.27942 0.55L12.0426 8.8C12.389 9.4 11.956 10.15 11.2631 10.15H1.73686C1.04404 10.15 0.611027 9.4 0.957437 8.8L5.72058 0.549999Z"
                                                    fill="#7D71E2"
                                                    stroke="#3F5765"
                                                />
                                            </svg>
                                            Metric Specific Conversation
                                        </span>
                                        <span style={styles.monthTitle} className="ms-2 metricbargraph">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="10"
                                            height="10"
                                            viewBox="0 0 10 10"
                                            fill="#00D6BB"
                                            stroke="#3F5765"
                                        >
                                            <path
                                                d="M0.375278 5.45C0.214508 5.17154 0.214508 4.82846 0.375278 4.55L2.29793 1.21987C2.4587 0.941411 2.75581 0.769873 3.07735 0.769873H6.92265C7.24419 0.769873 7.5413 0.941411 7.70207 1.21987L9.62472 
                                                4.55C9.78549 4.82846 9.78549 5.17154 9.62472 5.45L7.70207 8.78013C7.5413 9.05859 7.24419 9.23013 6.92265 9.23013H3.07735C2.75581 9.23013 2.4587 9.05859 2.29793 8.78013L0.375278 5.45Z"
                                            />
                                        </svg>
{' '}
                                            Other Conversation{' '}
                                        </span>
                                    </div>
                                </div>
      </div>

                              

      <Dialog
                header={modalHeader}
                footer={modalFooter}
                visible={displayModal}
                style={{ width: '60vw' }}
                onHide={() => {
                    setDisplayModal(false);
                    setCommentView(false);
                    setIsResponse(false);
                }}
            >
                <ReadConversationModalBody
                    listItem={selectedRowItem}
                    setSelectedRowItem={setSelectedRowItem}
                    setCommentView={setCommentView}
                    setIsResponse={setIsResponse}
                    commentView={commentView}
                    isResponse={isResponse}
                    receiverName={selectedRowItem?.recipient}
                    receiverId={selectedRowItem?.recipient?.split('(')[1]?.slice(0, 7)}
                    coreValueId={selectedRowItem?.core_value_id}
                    convId={selectedRowItem?.coaching_conversation_id}
                    setDisplayModal={setDisplayModal}
                    acknowledged={selectedRowItem?.acknowledged}
                />
            </Dialog>

            {showMetricModal && renderMetricModel()}
    </div>
  );
};

export default AgentDiscussionsPlot;